"use client"

import { CreationWizard } from "@/features/create/components/creation-wizard"
import { WizardAmbientBackground } from "@/features/create/components/wizard-ambient-background"
import { useCharacterStore } from "@/features/characters/store"
import { ErrorBoundary } from "@/shared/components/error-boundary"
import { Icon } from "@/shared/components/icons"

function WizardErrorFallback() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <div className="flex size-16 items-center justify-center rounded-full bg-destructive/10">
        <Icon name="attention-triangle" size={32} className="size-8 text-destructive" />
      </div>
      <h2 className="heading-serif mt-6 text-xl text-foreground sm:text-2xl">
        We couldn&apos;t load the creator
      </h2>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">
        Something interrupted the page. Reload to pick up where you left off —
        your progress is saved.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-6 inline-flex min-h-11 items-center justify-center rounded-full bg-accent-blue px-8 py-3 text-sm font-bold text-white transition-colors hover:bg-accent-blue/90"
      >
        Reload
      </button>
    </div>
  )
}

export function CreateContent() {
  const createWizardEpoch = useCharacterStore((s) => s.createWizardEpoch)

  return (
    <div>
      <WizardAmbientBackground />
      <div className="relative z-10">
        <ErrorBoundary scope="create-wizard" fallback={WizardErrorFallback}>
          <CreationWizard key={`create-wizard-${createWizardEpoch}`} />
        </ErrorBoundary>
      </div>
    </div>
  )
}
